export default {
  'global.contract_not_bound': 'Pending Contract Confirmation',
  'global.returnHome' : 'Return to Home',
  'global.name': 'Name',
  'global.description': 'Description',
  'global.updatedtime': 'Updated time',
  'global.createdtime': 'Created time',
  'global.new': 'New',
  'global.searchText': 'Search',
  'global.resetText': 'Reset',
  'global.expandText': 'Expand',
  'global.collapseText': 'Collapse',
  'global.operation': 'Operation',
  'global.confirmDelete': 'Delete this item?',
  'global.confirm': 'Confirm',
  'global.cancel': 'Cancel',
  'global.save': 'Save',
  'global.update': 'Update',
  'global.delete': 'Delete',
  'global.company': 'Company',
  'global.partner': 'Partner',
  'global.email': 'Email',
  'global.customer': 'Customer',
  'global.rank': 'Rank',
  'global.country': 'Country',
  'global.product': 'Product',
  'global.reference': 'Reference',
  'global.download': 'Download',
  'global.unknown': 'Unknown',

  //-- 产品相关指标多语言
  'global.allChannels': 'All Channels',
  'global.selectChannels': 'Select Channels',
  'global.subChannels': 'Sub-Channels',
  'global.dau': 'DAU',
  'global.mau': 'MAU',
  'global.totalUsers': 'Total Users',
  'global.totalPlayDuration': 'Total Play Duration',
  'global.playDuration': 'Play Duration(h)',
  'global.totalPlayCount': 'Total Play Count',
  'global.playCount': 'Play Count',
  'global.totalPlayUsers': 'Total Play Users',
  'global.playUsers': 'Play Users',
  'global.dailyActiveUsers': 'Daily Active Users',
  'global.averageActiveUsers': 'Average Active Users',
  'global.totalContentDeeplinkClick': 'Deeplink Clicks',
  'global.top10DeeplinkContents': 'Top 10 Deeplink Contents',
  'global.top10ChannelsPreferredByUsers': 'The 10 Contents Most Preferred By Users',
  'global.avgEngagementTimePerActiveUser': 'Average Engagement Time Per Active User',
  'global.averageEngagementTime': 'Average Engagement Time',
  'global.usersByTop10Countries': 'Users By Top 10 Countries',
  'global.revenueByTop10Countries': 'Revenue By Top 10 Countries',
  'global.totalAppUsageTime': 'Total App Usage Time',
  'global.top10CustomerRevenue': 'Top 10 Customer Revenue',
  'global.image': 'Image',
  'global.title': 'Title',
  'global.category': 'Category',
  'global.trend': 'Trend',
  'global.channelAnalytics': 'Content Analytics',
  'global.dimensions': 'Dimensions',
  'global.metrics': 'Metrics',
  'global.filters': 'Filters',
  'global.channelName': 'Content Name',
  'global.channelCategory': 'Content Category',

  //-- 广告相关指标多语言
  'global.adIndex': 'Ad Index',
  'global.adRequests': 'Ad Requests',
  'global.impressions': 'Impressions',
  'global.win': 'Bid Responses',
  'global.fillrate': 'Fill Rate',
  'global.viewrate': 'View Rate',
  'global.firstQuartile': 'First Quartile(25%)',
  'global.midpoint': 'Midpoint(50%)',
  'global.thirdQuartile': 'Third Quartile(75%)',
  'global.complete': 'Complete(100%)',
  'global.ecpm': 'eCPM($)',
  'global.ecpmRevenue': 'eCPM Revenue($)',
  'global.nonEcpmRevenue': 'Non-eCPM Revenue($)',
  'global.totalRevenue': 'Total Revenue($)',
  'global.netRevenue': 'Net Revenue($)',
  'global.grossRevenue': 'Gross Revenue($)',
  'global.ssaiCost': 'SSAI Cost($)',

  //-- 时间相关多语言
  'global.customDateRange': 'Custom Date Range',
  'global.today': 'Today',
  'global.yesterday': 'Yesterday',
  'global.last7days': 'Last 7 Days',
  'global.last14days': 'Last 14 Days',
  'global.thisMonth': 'This Month',
  'global.lastMonth': 'Last Month',
  'global.last3Month': 'Last 3 Months',
  'global.last6Month': 'Last 6 Months',
  'global.last12Month': 'Last 12 Months',
  'global.dateRange': 'Date Range',
  'global.updatetime': 'Update Time',
  'global.day': 'Day',
  'global.week': 'Week',
  'global.month': 'Month',
  'global.year': 'Year',
  'global.date': 'Date',
};
